import React, { useEffect } from "react";
import footer_logo from "../assets/images/footer_logo.png";
import Playstore from "../assets/images/Playstore.png";
import appStore from "../assets/images/appStore.png";
import { Col, Container, Image, Row } from "react-bootstrap";
import AOS from "aos";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
} from "react-router-dom";
const Footer = ({ footerStyle }) => {
  const history = useHistory();
  // console.log(
  //   history.location.pathname === "/AllJobs" ? (footerStyle = true) : (footerStyle = false)
  // );
  // console.log(footerStyle);
  // console.log("footer", footerStyle);
  useEffect(() => {
    // ourClassesApiFunc();
    AOS.init({once: true});
  }, []);
  return (
    <div className="footer-div">
    <div className={footerStyle ? "footer_bg no_mar" : "footer_bg "}>
      <Container className="small_container" >
        <Row>
          <Col md={4}>
            <Image className="img-fluid" src={footer_logo} />
            <p className="mt-5" data-aos="fade-right">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore.
            </p>
            <div className="footer_social_div">
              <div>
                <i class="fab fa-facebook-f"></i>
              </div>

              <div>
                <i class="fab fa-instagram"></i>
              </div>

              <div>
                <i class="fab fa-google"></i>
              </div>

              <div>
                <i class="fab fa-linkedin-in"></i>
              </div>
            </div>
          </Col>
          <Col md={2} className="footer_col_setting2">
            <div>
              <h5 className="footer_title">Quick Links</h5>
              <Link to="/" className="footerLink">
                <p>Home</p>
              </Link>
              <Link to="/Companies" className="footerLink">
                <p>Companies</p>
              </Link>
              <Link to="/Craftmen" className="footerLink">
                <p>Craftsmen</p>
              </Link>
              <Link to="/AllJobs" className="footerLink">
                <p>All Jobs</p>
              </Link>
              <Link to="/aboutus" className="footerLink">
                <p>About us</p>
              </Link>
            </div>
          </Col>
          <Col md={3} className="footer_col_setting3">
            <div>
              <h5 className="footer_title">Support</h5>
              {/* <Link to="/" className="footerLink">
                <p>Account</p>
              </Link> */}
              <Link to="/contactus" className="footerLink">
                <p>Support Centre</p>
              </Link>
              <Link to="/contactus" className="footerLink">
                <p>Contact</p>
              </Link>
            </div>
          </Col>
          <Col md={3}>
            <h5 className="footer_title">Download Our App</h5>
            <a className="playstore_btn" href="#!">
              <Image className="mb-3 img-fluid" src={Playstore} />
            </a>
            <a className="applestore_btn" href="#!">
            <Image className="img-fluid" src={appStore} />
            </a>
          </Col>
        </Row>
        <Row className="row_translate">
          <Col>
            <div className="d-flex">
              <p>Copyright © 2021 Domain. All Rights Reserved.</p>
              <p
                className="c-p"
                onClick={() => history.push("/terms-and-conditions")}
              >
                Terms & Conditions
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    </div>
  );
};

export default Footer;
